// extracted by mini-css-extract-plugin
export default {"timeline":"Timeline_timeline__6HQRq","current_time":"Timeline_current_time__Ux0L-"};